import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DialogState } from "./dialog.state";
import { DialogItem } from "./dialog.types";

const initialState: DialogState = {
  dialogs: [],
};

const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    appendDialog: (state, action: PayloadAction<DialogItem>) => {
      state.dialogs.push(action.payload);
    },
    destroy: (state) => {
      state.dialogs.pop();
    },
    destroyAll: (state) => {
      state.dialogs = [];
    },
  },
});

export const { appendDialog, destroy, destroyAll } = dialogSlice.actions;
export default dialogSlice.reducer;
